import { useTranslation } from 'react-i18next';
import { ModulePlaceholderForm } from '../../components/ModulePlaceholderForm';

export default function NewTravel() {
  const { t } = useTranslation('panel');
  return (
    <ModulePlaceholderForm
      title="New travel request"
      listPath="/panel/travels"
      tabs={[
        {
          key: 'basic',
          label: t('form.tabs.basic'),
          fields: [
            { key: 'employeeId', label: 'Employee', required: true },
            { key: 'purpose', label: 'Purpose of travel', required: true },
            {
              key: 'travelType',
              label: 'Travel type',
              type: 'select',
              options: [
                { value: 'domestic', label: 'Domestic' },
                { value: 'international', label: 'International' },
              ],
            },
          ],
        },
        {
          key: 'details',
          label: t('form.tabs.details'),
          fields: [
            { key: 'fromCity', label: 'From', required: true },
            { key: 'toCity', label: 'To', required: true },
            { key: 'departDate', label: 'Departure date', type: 'date', required: true },
            { key: 'returnDate', label: 'Return date', type: 'date' },
            { key: 'estimatedCost', label: 'Estimated cost (₹)', type: 'number' },
          ],
        },
        {
          key: 'documents',
          label: t('form.tabs.documents'),
          fields: [
            { key: 'itineraryUrl', label: 'Itinerary URL' },
            { key: 'visaStatus', label: 'Visa status' },
            { key: 'notes', label: 'Notes', type: 'textarea' },
          ],
        },
        { key: 'review', label: t('form.tabs.review'), fields: [] },
      ]}
    />
  );
}
